export default __webpack_public_path__ + "static/media/yt.f50bd413.svg";